import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CloseButton from "./components/Snackbar/closeIcon";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
        <ToastContainer
            className='containerToast'
            position="top-right"
            autoClose={3000}
            icon={false}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            closeButton={CloseButton}
        />
    </React.StrictMode>
)
;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
